module.exports = __webpack_public_path__ + "static/media/aajubaajutmlogo.9e04c657.svg";